<template>
    <button
        type="button"
        class="calc-toggle"
        :class="[modelValue ? 'calc-toggle--on' : 'calc-toggle--off', { 'calc-toggle--disabled': disabled }]"
        role="switch"
        :aria-checked="modelValue"
        :disabled="disabled"
        @click="onToggle"
    >
        <span class="calc-toggle__knob" />
        <span class="calc-toggle__text">{{ displayedLabel }}</span>
    </button>
</template>

<script>
export default {
    name: 'CalcToggle',

    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        labelOn: {
            type: String,
            default: '§calc.step2.toggle.yes',
        },
        labelOff: {
            type: String,
            default: '§calc.step2.toggle.no',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['update:modelValue'],

    computed: {
        displayedLabel() {
            const key = this.modelValue ? this.labelOn : this.labelOff
            if (typeof key === 'string' && key.startsWith('§')) {
                return this.$t(key)
            }
            return key
        },
    },

    methods: {
        onToggle() {
            if (this.disabled) return
            this.$emit('update:modelValue', !this.modelValue)
        },
    },
}
</script>

<style scoped>
.calc-toggle {
    position: relative;
    width: 56px;
    height: 28px;
    border-radius: 100px;
    background: var(--calc-ink);
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    transition: background var(--calc-t-med);
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 9px;
    letter-spacing: 0.06em;
    color: white;
    user-select: none;
    border: none;
    padding: 0;
}

.calc-toggle--on {
    background: var(--calc-green-accent);
}

.calc-toggle--disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.calc-toggle__knob {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 22px;
    height: 22px;
    border-radius: 100px;
    background: white;
    transition: left var(--calc-t-med);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
}

.calc-toggle--on .calc-toggle__knob {
    left: 31px;
}

.calc-toggle__text {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    transition:
        left var(--calc-t-med),
        color var(--calc-t-med);
}

.calc-toggle--off .calc-toggle__text {
    left: 30px;
}

.calc-toggle--on .calc-toggle__text {
    left: 8px;
    color: white;
}
</style>
